module.exports = __webpack_public_path__ + "static/media/cake craft.bf82dc4d.png";